__turbopack_context__.v({
  "actions": "w4WuEq_actions",
  "avatar": "w4WuEq_avatar",
  "badge": "w4WuEq_badge",
  "notificationBtn": "w4WuEq_notificationBtn",
});
